/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_Field_ModalitiesInputs */

const en_us2_search_field_modalities = /** @type {(inputs: Search_Field_ModalitiesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Other sports`)
};

const pt_br2_search_field_modalities = /** @type {(inputs: Search_Field_ModalitiesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modalidades`)
};

const es_419_search_field_modalities = /** @type {(inputs: Search_Field_ModalitiesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Otros deportes`)
};

const pt_pt2_search_field_modalities = /** @type {(inputs: Search_Field_ModalitiesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Outras modalidades`)
};

const fr_fr2_search_field_modalities = /** @type {(inputs: Search_Field_ModalitiesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Autres sports`)
};

const de_de2_search_field_modalities = /** @type {(inputs: Search_Field_ModalitiesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Andere Sportarten`)
};

const it_it2_search_field_modalities = /** @type {(inputs: Search_Field_ModalitiesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Altri sport`)
};

/**
* | output |
* | --- |
* | "Other sports" |
*
* @param {Search_Field_ModalitiesInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const search_field_modalities = /** @type {((inputs?: Search_Field_ModalitiesInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_Field_ModalitiesInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_search_field_modalities(inputs)
	if (locale === "es-419") return es_419_search_field_modalities(inputs)
	if (locale === "pt-PT") return pt_pt2_search_field_modalities(inputs)
	if (locale === "fr-FR") return fr_fr2_search_field_modalities(inputs)
	if (locale === "de-DE") return de_de2_search_field_modalities(inputs)
	if (locale === "it-IT") return it_it2_search_field_modalities(inputs)
	return en_us2_search_field_modalities(inputs)
});
export { search_field_modalities as "search.field_modalities" }